import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EnrichmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Enrichment",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m5.31 6.79 1.19 2.2c.34.61.82 1.1 1.43 1.44l2.18 1.2-2.18 1.2c-.61.34-1.09.83-1.43 1.44l-1.19 2.2-1.19-2.2c-.34-.61-.82-1.1-1.43-1.44l-2.18-1.2 2.18-1.2c.61-.34 1.09-.83 1.43-1.44zM13.74 3.62l.8 1.48c.23.41.55.74.96.97l1.47.81-1.47.81c-.41.23-.74.56-.96.97l-.8 1.48-.8-1.48c-.23-.41-.55-.74-.96-.97l-1.47-.81 1.47-.81c.41-.23.74-.56.96-.97zM31.31 12.75c.24.22.26.59.04.84L18.3 28.19a.58.58 0 0 1-.84.03l-8.14-7.88a.607.607 0 0 1-.02-.84l2.31-2.42c.23-.24.6-.24.83-.02l5.22 5.05L28 10.54c.22-.24.59-.26.83-.04z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.71 15.43c-3.79 0-6.86-3.07-6.86-6.86 0 3.79-3.07 6.86-6.86 6.86 3.79 0 6.86 3.07 6.86 6.86 0-3.79 3.07-6.86 6.86-6.86"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.86 23.43c-.63 0-1.14-.51-1.14-1.14 0-3.15-2.56-5.71-5.71-5.71a1.14 1.14 0 1 1 0-2.28c3.15 0 5.71-2.56 5.71-5.71a1.14 1.14 0 1 1 2.28 0c0 3.15 2.56 5.71 5.71 5.71a1.14 1.14 0 1 1 0 2.28c-3.15 0-5.71 2.56-5.71 5.71 0 .63-.51 1.14-1.14 1.14m-2.74-8a8.16 8.16 0 0 1 2.74 2.74 8.16 8.16 0 0 1 2.74-2.74 8.16 8.16 0 0 1-2.74-2.74 8.16 8.16 0 0 1-2.74 2.74M25 8.57c-2.52 0-4.57 2.05-4.57 4.57 0-2.52-2.05-4.57-4.57-4.57 2.52 0 4.57-2.05 4.57-4.57 0 2.53 2.05 4.57 4.57 4.57"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.43 14.28c-.63 0-1.14-.51-1.14-1.14 0-1.89-1.54-3.43-3.43-3.43a1.14 1.14 0 1 1 0-2.28c1.89 0 3.43-1.54 3.43-3.43a1.14 1.14 0 1 1 2.28 0c0 1.89 1.54 3.43 3.43 3.43a1.14 1.14 0 1 1 0 2.28c-1.89 0-3.43 1.54-3.43 3.43 0 .63-.51 1.14-1.14 1.14m-1.15-5.71c.43.33.82.71 1.15 1.15.33-.43.71-.82 1.15-1.15-.43-.33-.82-.71-1.15-1.15-.33.43-.71.82-1.15 1.15M21.57 29.14c-.3 0-.59-.12-.81-.33l-4.57-4.57a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.76 3.76 8.33-8.33a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-9.14 9.14c-.21.21-.5.33-.81.33"
      })]
    })
  }));
};
EnrichmentIcon.displayName = 'EnrichmentIcon';